import styled from "styled-components";

export const EventsPageStyle = styled.div`
  /* Add your styles here */

  .custom-container {
    min-height: 84vh;
  }

  .title-box {
    cursor: pointer;
  }
  /* h3 {
    padding-top: var(--size2);
  } */

  .year-section h3 {
    display: ${(props) => (!props.showmore.exhibitions ? "none" : "")};
  }

  .exhibitions:not(:first-child) {
    display: ${(props) => (!props.showmore.exhibitions ? "none" : "")};
  }

  .exhibitions:first-child .main-title {
    display: ${(props) => (!props.showmore.exhibitions ? "none" : "")};
  }

  .virtual-tours:not(:first-child) {
    display: ${(props) => (!props.showmore.virtualTours ? "none" : "")};
  }

  .virtual-tours:first-child .title-box {
    display: ${(props) => (!props.showmore.virtualTours ? "none" : "")};
  }

  .oasis:not(:first-child) {
    display: ${(props) => (!props.showmore.oasis ? "none" : "")};
  }

  .oasis:first-child .title-box {
    display: ${(props) => (!props.showmore.oasis ? "none" : "")};
  }

  .virtual-tours-container,
  .oasis-container {
    margin-top: var(--size3);
  }

  iframe,
  mux-player {
    width: 100%;
  }

  .virtual-tours-container .event-item {
    flex-direction: column;
    height: auto;

    .text {
      width: 100%;
    }

    div {
      width: 100%;
    }
  }

  .main-title {
    text-transform: capitalize;
  }

  @media (max-width: 900px) {
    .small-title-box {
      margin-bottom: 0;
      padding-top: var(--size1);
    }
    .gatsby-image-wrapper img {
      object-fit: contain !important;
    }
    .year-section {
      h3 {
        padding-top: var(--size2);
      }
    }
  }
`;

export const EventItemStyle = styled.div`
  .slick-slider {
    width: calc(64% - var(--size1));
  }

  /* height: ${(props) => (props.readmore ? "auto" : "31vh")}; */
  margin-bottom: var(--size2);
  padding-top: var(--size2);
  gap: var(--size2);
  justify-content: space-between;
  /* border-top: 1px solid; */
  overflow: hidden;

  .flex-column {
    justify-content: flex-start;
    /* justify-content: ${(props) =>
      props.readmore ? "flex-start" : "space-between"}; */
  }
  .text {
    width: calc(36% - var(--size2));
    /* height: ${(props) => (props.readmore ? "auto" : "35vh")}; */
  }

  .gatsby-image-wrapper {
    width: 100%;
  }

  .gatsby-image-wrapper img {
    /* cursor: grabbing; */
    width: calc(100% - 45px);
    object-position: center;
    left: 20px;
    height: ${(props) => (props.readmore ? "auto" : "19rem")};
    max-height: 80vh;
    object-fit: ${(props) => (props.readmore ? "contain !important" : "")};
  }

  .slider {
    cursor: grabbing;
  }

  .one-image {
    width: calc(64% - var(--size1));
  }
  .slick-prev {
    left: -0.75rem;

    z-index: 5;
  }
  .slick-next {
    right: -0.5rem;
  }

  .slick-next,
  .slick-prev {
    color: var(--green);
    font-size: var(--size2);

    width: auto;
    height: auto;
  }

  .slick-next:hover,
  .slick-prev:hover {
    color: var(--green);
    font-size: var(--size2);
    width: auto;
    height: auto;
  }

  .big-ellipsis {
    -webkit-line-clamp: ${(props) => (props.readmore ? "inherit" : "5")};
  }

  .big-bold-title {
    margin-bottom: var(--size2);
    min-height: 6rem;
  }

  h5 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;

    padding-bottom: 0;
  }

  mux-player {
    height: ${(props) => (props.readmore ? "auto" : "19rem")};
  }

  @media (max-width: 900px) {
    && > div {
      width: 100%;
    }
    .big-bold-title {
      min-height: inherit;
    }

    img {
      object-fit: contain;
    }
    height: inherit;
    margin-top: 0;
    /* height: 28vw; */
    flex-direction: column;
    .text {
      width: calc(100% - var(--size05));
    }
  }
`;

export const SubEventsGroupStyle = styled.div`
  /* .current:not(:first-child) {
    display: ${(props) => (!props.showmore.current ? "none" : "")};

  } */

  .year-section:not(:first-child) {
    margin-top: var(--size3);
  }

  .current .year-section h3 {
    display: ${(props) => (!props.showmore.current ? "none" : "")};
  }

  .current .year-section .border-top-event:not(:first-child) {
    border-top: ${(props) =>
      !props.showmore.current ? "none" : "1px solid var(--green)"};
  }

  .current:first-child h3 {
    display: ${(props) => (!props.showmore.current ? "none" : "")};
  }

  .previous .year-section h3 {
    display: ${(props) => (!props.showmore.previous ? "none" : "")};
  }

  .previous .year-section:not(:first-child) {
    display: ${(props) => (!props.showmore.previous ? "none" : "")};
  }

  .previous .year-section:first-child h3 {
    display: ${(props) => (!props.showmore.previous ? "none" : "")};
  }
  .previous .year-section .border-top-event:not(:first-child) {
    border-top: ${(props) =>
      !props.showmore.previous ? "none" : "1px solid var(--green)"};
  }

  .artFair .year-section h3 {
    display: ${(props) => (!props.showmore.artFair ? "none" : "")};
  }
  .artFair .year-section:not(:first-child) {
    display: ${(props) => (!props.showmore.artFair ? "none" : "")};
  }

  .artFair .year-section:first-child h3 {
    display: ${(props) => (!props.showmore.artFair ? "none" : "")};
  }
  .artFair .year-section .border-top-event:not(:first-child) {
    border-top: ${(props) =>
      !props.showmore.artFair ? "none" : "1px solid var(--green)"};
  }
`;
